import { render, staticRenderFns } from "./add-row.vue?vue&type=template&id=107f12fc&"
import script from "./add-row.vue?vue&type=script&lang=js&"
export * from "./add-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports